import React, {useCallback, useEffect} from 'react';
import * as Yup from 'yup';
import {Form, Tabs} from '@components';
import {Row, Col} from 'react-bootstrap';
// import {useTranslation} from 'react-i18next';
import {RedButton} from '@styled';
import OwnerDashboardFilters from '@modules/dashboard/OwnerDashboardFilters';
import OwnerDashboardGlobalView from '@modules/dashboard/OwnerDashboardGlobalView';
import OwnerDashboardCorporates from '@modules/dashboard/OwnerDashboardCorporates';
import {useDispatch, useSelector} from 'react-redux';
import {sagaActions} from '@modules/dashboard/redux/saga';
import OwnerDashboardCorporateFacilities from '@modules/dashboard/OwnerDashboardCorporateFacilities';

const OwnerDashboard = () => {
  // const [t] = useTranslation();
  const dispatch = useDispatch();
  const selectedCorporate = useSelector(
    (state) => state.dashboard.selectedCorporate
  );

  useEffect(() => {}, []);

  const listTabCB = useCallback(
    (isActive) => {
      if (selectedCorporate) {
        return <OwnerDashboardCorporateFacilities isActive={isActive} />;
      }
      return <OwnerDashboardCorporates isActive={isActive} />;
    },
    [selectedCorporate]
  );
  // const mapTabCB = useCallback(() => <div>Map</div>, []);

  const getTabItems = () => {
    const tabs = [
      {
        tabKey: 'list',
        tabLabel: 'List',
        position: 1,
        content: listTabCB,
      },
      // {
      //   tabKey: 'map',
      //   tabLabel: 'Map',
      //   position: 2,
      //   content: mapTabCB,
      // },
    ];
    return tabs;
  };

  const handleRemoveCorporate = () => {
    dispatch({type: sagaActions.SELECT_CORPORATE, payload: {corporate: null}});
  };

  return (
    <div>
      <section className="content">
        <div className="container-fluid">
          <h1>Dashboard</h1>

          <Form
            initialValues={{
              reportYear: {label: '2022', value: '2022'},
              reportSector: '',
              sourceCategory: '',
              emissionSource: '',
              fuelType: '',
              country: '',
            }}
            validationSchema={Yup.object({})}
            onSubmit={(values) => {
              console.log('onSubmit', values);
            }}
          >
            <OwnerDashboardGlobalView />
            <OwnerDashboardFilters />
            <Row>
              <Col>
                <span className="font-weight-bold">Corporate:</span> Showing{' '}
                {selectedCorporate ? (
                  <span>
                    {selectedCorporate.name}{' '}
                    <RedButton
                      size="sm"
                      style={{padding: '0 5px'}}
                      onClick={handleRemoveCorporate}
                    >
                      <i className="fa fa-times" />
                    </RedButton>{' '}
                  </span>
                ) : (
                  'all'
                )}{' '}
                <span style={{color: 'green'}}>
                  (Click on corporate name to show details of corporate
                  entities)
                </span>
              </Col>
            </Row>
            <div className="mt-1">
              <Tabs
                id="corporates-list-tabs"
                defaultTab="list"
                tabs={getTabItems()}
                tabPaneMinHeight="300px"
                contentOverflow="auto"
              />
            </div>
          </Form>
        </div>
      </section>
    </div>
  );
};

export default OwnerDashboard;
